import updateUserPassword from "@/utils/updatePassword";
import Button from "./UI/Button";
import { PasswordInput } from "./UI/PasswordInput";
import { useState } from "react";
import { errorMessages } from "@/assets/data/firebaseErrorMessage";

const UpdatePassword = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const updateUsePasswordConfirm = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      setErrorMessage("Все поля должны быть заполнены!");
      setSuccessMessage("");
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage("Пароли не совпадают!");
      setSuccessMessage("");
      return;
    }

    setLoading(true);

    try {
      const result = await updateUserPassword(currentPassword, newPassword);

      if (!result.success) {
        throw new Error(result.message || "Не удалось обновить пароль.");
      }

      setSuccessMessage(result.message);
      setErrorMessage("");
    } catch (error) {
      const errorCode = error?.message || "default";
      setErrorMessage(errorMessages[errorCode] || errorMessages.default);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="accountInfo">
      <form className="accountInfo-body">
        <div className="accountInfo-body-item">
          <label htmlFor="currentPassword">Текущий пароль</label>
          <PasswordInput
            value={currentPassword}
            onChange={setCurrentPassword}
          ></PasswordInput>
        </div>

        <div className="authentication-box-passwords">
          <div className="accountInfo-body-item">
            <label htmlFor="password">Новый пароль</label>
            <PasswordInput value={newPassword} onChange={setNewPassword} />
          </div>
          <div className="accountInfo-body-item">
            <label htmlFor="password-confirm">Потдверждение</label>

            <PasswordInput
              value={confirmPassword}
              onChange={setConfirmPassword}
            />
          </div>
        </div>

        <p className="authentication-box__desc">
          Ваш пароль должен соответствовать следующим требованиям: минимум 6
          символов, хотя бы одна заглавная буква и хотя бы одна цифра.
        </p>
        {loading ? (
          <Button
            title="Обновление"
            color="black"
            disabled
            onClick={updateUsePasswordConfirm}
          />
        ) : (
          <Button
            title="Обновить"
            color="blue"
            onClick={updateUsePasswordConfirm}
          />
        )}
        {errorMessage && (
          <p className="authentication-box__error"> {errorMessage} </p>
        )}
        {successMessage && (
          <p className="authentication-box__success"> {successMessage} </p>
        )}
      </form>
    </div>
  );
};

export default UpdatePassword;
